export default {
      id: "calendar-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#calendar-usage",
      toString: function () {
        return this.url;
      }
    }